import { etapaUniforme, ctxDeEntrega } from './uniformesReglas'

// Los bloques de la pantalla de armar el pedido.
//
// El orden lo dicto el dueno: "se mandan a hacer todas las ya pagadas. Entonces hay
// q saber de las ya pagadas cuales les faltan datos de tallas, y de ahi se arma el
// pedido." El PAGO manda; la talla es el dato que falta para poder producir.
//
// Antes, "Por pedir" (agruparNecesidades) solo miraba la talla y era CIEGO al pago
// -- la pantalla que decide que producir no mostraba lo unico que lo decide.
//
// OJO con los dos candados: se clasifica por `prendaPagada` (el dinero del jersey),
// NO por la condicion de entrega (la mensualidad amarrada). El primero decide que se
// manda a hacer; el segundo, que se entrega. Son dos momentos distintos.
//
// `sinPagoPropio` existe aparte de `sinPagar` a proposito: una prenda cuyo costo esta
// disuelto en el plan no tiene pago propio que consultar, y eso NO es lo mismo que no
// haber pagado. Meterlas juntas haria mentir a la pantalla.
export const clasificarParaPedido = (entregas = []) => {
  const out = { listas: [], pagadasSinTalla: [], sinPagar: [], sinPagoPropio: [] }

  ;(entregas || []).forEach((e) => {
    if (e.estatus === 'entregado') return
    // Ya comprometida en un pedido vivo: no se vuelve a pedir.
    const etapa = etapaUniforme(e, ctxDeEntrega(e))
    if (['en_pedido', 'pedido', 'recibido'].includes(etapa)) return

    const sinCobroPropio = e.prendaPagada === null || e.prendaPagada === undefined

    // Hay DOS senales validas de que una prenda se puede mandar a hacer:
    //
    //   1. Su propio cobro esta pagado.
    //   2. No tiene cobro propio, pero el plan puso una condicion ("el uniforme se
    //      libera al Pago 1") y ya se cumplio.
    //
    // La segunda es la unica que existe cuando el uniforme va disuelto en el total del
    // plan. Sin ella, un club que ya cobro su uniforme dentro de la mensualidad no
    // podia mandar a hacer nada: todo caia en "Sin cobro propio".
    //
    // OJO con el orden: la condicion NO rescata a quien SI tiene cobro propio y no lo
    // pago. Ir al corriente de la mensualidad no paga el jersey.
    if (e.prendaPagada === true || (sinCobroPropio && e.condicionCumplida === true)) {
      if (e.talla) out.listas.push(e)
      else out.pagadasSinTalla.push(e)
      return
    }
    if (sinCobroPropio) out.sinPagoPropio.push(e)
    else out.sinPagar.push(e)
  })

  return out
}
